export default __webpack_public_path__ + "static/media/bg-polisport-plastics.ff41c3d5.jpg";